import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import theme from "assets/theme";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import CookieConsent from "components/CookieConsent";

// Critical pages - Load immediately
import BlogPage from "pages/BlogPage";
import HomePage from "pages/HomePage";

// Non-critical pages - Lazy load for better performance
const ArticlePage = lazy(() => import("pages/ArticlePage"));
const AboutPage = lazy(() => import("pages/AboutPage"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("pages/TermsOfService"));
const RefundPolicy = lazy(() => import("pages/RefundPolicy"));
const ThankYouPage = lazy(() => import("pages/ThankYouPage"));
const UpgradePage = lazy(() => import("pages/UpgradePage"));
const NotFoundPage = lazy(() => import("pages/NotFoundPage"));

// Loading component
const PageLoader = () => (
  <div style={{
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}>
    <div>Loading...</div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
            }}
          >
            <Navbar />
            <Box sx={{ flex: 1 }}>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<ArticlePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/refund" element={<RefundPolicy />} />
                  <Route path="/thank-you" element={<ThankYouPage />} />
                  <Route path="/upgrade" element={<UpgradePage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Suspense>
            </Box>
            <Footer />
            <CookieConsent />
          </Box>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;

